// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#fff","menuActiveText":"#fff","subMenuActiveText":"#fff","menuBg":"#005f9e","menuHover":"#2d4c7f","subMenuBg":"rgba(0,0,0,0.2)","subMenuHover":"#2d4c7f","sideBarWidth":"240px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 184